module.exports = __webpack_public_path__ + "static/media/Cryptocurrency.60f68870.svg";